export default __webpack_public_path__ + "static/media/VOYAH.7e79d375.png";